// extracted by mini-css-extract-plugin
var _1 = "ApplicantProfileFollowUpItem-moduledatePickerWrap__Ou6pd DateInput-moduleDateInputWrap__ACpxG InputWrap-moduleInputWrap__X8g8b";
var _2 = "ApplicantProfileFollowUpItem-moduleeditFieldsWrapper__wEwfS";
export { _1 as "datePickerWrap", _2 as "editFieldsWrapper" }
